var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoPurcahseReplenishmentIconBlueClipped(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50963_31364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8993 2.76562H13.0593C12.2456 2.76562 11.5859 3.42526 11.5859 4.23896V7.18563C11.5859 7.99934 12.2456 8.65897 13.0593 8.65897H21.8993C22.713 8.65897 23.3726 7.99934 23.3726 7.18563V4.23896C23.3726 3.42526 22.713 2.76562 21.8993 2.76562Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3675 5.71094H26.3142C27.0957 5.71094 27.8452 6.02139 28.3978 6.574C28.9504 7.12661 29.2609 7.8761 29.2609 8.65761V15.7958M11.5808 5.71094H8.63417C7.85267 5.71094 7.10317 6.02139 6.55056 6.574C5.99795 7.12661 5.6875 7.8761 5.6875 8.65761V29.2843C5.6875 30.0658 5.99795 30.8153 6.55056 31.3679C7.10317 31.9205 7.85267 32.231 8.63417 32.231H15.7812",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22656 12.7812H16.5932",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22656 15.1406H12.4679",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1562 26.1592V25.2699C19.1562 24.7444 19.5857 24.3099 20.1163 24.3099C21.0308 24.3099 21.4047 23.6632 20.9449 22.8699C20.6822 22.4151 20.8388 21.8239 21.2986 21.5612L22.1728 21.061C22.5719 20.8235 23.0873 20.965 23.3248 21.3641L23.3804 21.4601C23.8351 22.2534 24.583 22.2534 25.0428 21.4601L25.0983 21.3641C25.3358 20.965 25.8512 20.8235 26.2504 21.061L27.1245 21.5612C27.5843 21.8239 27.741 22.4151 27.4782 22.8699C27.0184 23.6632 27.3923 24.3099 28.3069 24.3099C28.8324 24.3099 29.2669 24.7394 29.2669 25.2699V26.1592C29.2669 26.6847 28.8374 27.1193 28.3069 27.1193C27.3923 27.1193 27.0184 27.766 27.4782 28.5593C27.741 29.0191 27.5843 29.6052 27.1245 29.868L26.2504 30.3682C25.8512 30.6057 25.3358 30.4642 25.0983 30.065L25.0428 29.969C24.588 29.1757 23.8402 29.1757 23.3804 29.969L23.3248 30.065C23.0873 30.4642 22.5719 30.6057 22.1728 30.3682L21.2986 29.868C20.8388 29.6052 20.6822 29.0141 20.9449 28.5593C21.4047 27.766 21.0308 27.1193 20.1163 27.1193C19.5857 27.1193 19.1562 26.6847 19.1562 26.1592Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2098 26.8883C24.8563 26.8883 25.3804 26.3641 25.3804 25.7176C25.3804 25.071 24.8563 24.5469 24.2098 24.5469C23.5632 24.5469 23.0391 25.071 23.0391 25.7176C23.0391 26.3641 23.5632 26.8883 24.2098 26.8883Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2734 25.5C16.2734 27.0822 16.7426 28.629 17.6217 29.9446C18.5007 31.2602 19.7502 32.2855 21.212 32.891C22.6738 33.4965 24.2823 33.655 25.8342 33.3463C27.386 33.0376 28.8115 32.2757 29.9303 31.1568C31.0491 30.038 31.811 28.6126 32.1197 27.0607C32.4284 25.5089 32.27 23.9003 31.6645 22.4385C31.059 20.9767 30.0336 19.7273 28.718 18.8482C27.4024 17.9692 25.8557 17.5 24.2734 17.5C22.0369 17.5084 19.8903 18.3811 18.2823 19.9356L16.2734 21.9444",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4957 21.941H16.2734V19.7188",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50963_31364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.476562 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoPurcahseReplenishmentIconBlueClipped);
export default __webpack_public_path__ + "static/media/AutoPurcahseReplenishmentIconBlueClipped.681fd29ba9bf39940e4afe80d4d72227.svg";
export { ForwardRef as ReactComponent };